import React, { useRef, useImperativeHandle, forwardRef } from "react";
import html2pdf from "html2pdf.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { secondAxios as axios } from "../../../../../api/axios";
import { useParams } from "react-router-dom";

const PrintToPDF = forwardRef(
  ({ tableComponent, header, revNUm, type, folderPath }, ref) => {
    const contentRef = useRef();
    const projectId = useParams("projectId").id;

    useImperativeHandle(ref, () => ({
      generatePDF: async () => {
        console.log("Generating PDF...");

        if (contentRef.current) {
          const worker = html2pdf()
            .from(contentRef.current)
            .set({
              margin: 0.5,
              image: { type: "jpeg", quality: 0.98 },
              html2canvas: { scale: 2 },
              jsPDF: { unit: "in", format: "a3", orientation: "landscape" },
            });

          const pdfBlob = await worker.outputPdf("blob"); // Generate PDF as a Blob

          // Now send the blob to backend
          const formData = new FormData();
          formData.append("file", pdfBlob, "Estimation_Report.pdf"); // name it correctly
          formData.append("projectId", projectId);
          formData.append("folderPath", folderPath);
          formData.append("revNum", 0);
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(pdfBlob);
          downloadLink.download = "Estimation_Report.pdf";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          // await axios.post(`sharepoint/save/${type}`, formData, {
          //   headers: {
          //     "Content-Type": "multipart/form-data",
          //   },
          // });

          // console.log("PDF uploaded to server!");
        }
      },
    }));

    return (
      <div style={{ display: "none" }}>
        <div ref={contentRef}>
          <Box sx={{ p: 2, fontSize: 12, width: "100%" }}>
            <Typography variant="h5" align="center" gutterBottom>
              {header}
              {" - Revision No:  0 "}
              {revNUm}
            </Typography>
            {tableComponent}
          </Box>
        </div>
      </div>
    );
  }
);

export default PrintToPDF;
